import { render, staticRenderFns } from "./SectionSchedule.vue?vue&type=template&id=5b3cc991&scoped=true"
import script from "./SectionSchedule.vue?vue&type=script&lang=ts"
export * from "./SectionSchedule.vue?vue&type=script&lang=ts"
import style0 from "./SectionSchedule.vue?vue&type=style&index=0&id=5b3cc991&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3cc991",
  null
  
)

export default component.exports